<template>
    <div class="box-container" v-loading="loading"
        element-loading-text='数据加载中...'
        element-loading-spinner="el-icon-loading">
        <div style="width:100%;margin:0 auto;padding:15px;overflow:auto">
            <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
                <el-tab-pane label="未审批" name="first" >
                    <div class="scrollLoad" v-infinite-scroll="loadList"
                        infinite-scroll-disabled="loading">
                        <el-card class="box-card" v-for="(item, idx) in result" :key="idx">
                            <div slot="header" class="clearfix">
                                <span style="color:red">未审批</span>
                                <el-button style="float: right; padding: 3px 0" type="text" @click="getInfo(item.formId,1)">查看详情</el-button>
                            </div>
                            <div class="text item">
                                {{'审批类型：'+item.flowNodeName}}
                            </div>
                            <div class="text item">
                                {{'访问人：'+item.visitorName}}
                            </div>
                            <div class="text item">
                                {{'被访人：'+item.intervieweeName}}
                            </div>
                            <div class="text item">
                                {{'被访人部门：'+item.intervieweeOrgName}}
                            </div>
                            <div class="text item">
                                {{'访问类型：'+item.visitTypeName}}
                            </div>
                            <div class="text item">
                                {{'访问开始时间：'+item.visitStartTime}}
                            </div>
                            <div class="text item">
                                {{'访问结束时间：'+item.visitEndTime}}
                            </div>
                            
                            <!--<div v-for="o in 4" :key="o" class="text item">
                                {{'列表内容 ' + o }}
                            </div>-->
                        </el-card>
                    </div>                    
                </el-tab-pane>
                <el-tab-pane label="已审批" name="second">
                    <div class="scrollLoad" v-infinite-scroll="loadList"
                        infinite-scroll-disabled="loading">
                            <el-card class="box-card" v-for="(item, idx) in result" :key="idx">
                            <div slot="header" class="clearfix">
                                <span style="color:	#32CD32" v-if="item.flowStateNum==auditTypeEnEnum.passed">{{auditTypeEnum.passed}}</span>
                                <span style="color:	red" v-if="item.flowStateNum==auditTypeEnEnum.rejected">{{auditTypeEnum.rejected}}</span>
                                <el-button style="float: right; padding: 3px 0" type="text" @click="getInfo(item.formId,2)">查看详情</el-button>
                            </div>
                            <div class="text item">
                                {{'审批类型：'+item.flowNodeName}}
                            </div>
                            <div class="text item">
                                {{'访问人：'+item.visitorName}}
                            </div>
                            <div class="text item">
                                {{'被访人：'+item.intervieweeName}}
                            </div>
                            <div class="text item">
                                {{'被访人部门：'+item.intervieweeOrgName}}
                            </div>
                            <div class="text item">
                                {{'访问类型：'+item.visitTypeName}}
                            </div>
                            <div class="text item">
                                {{'访问开始时间：'+item.visitStartTime}}
                            </div>
                            <div class="text item">
                                {{'访问结束时间：'+item.visitEndTime}}
                            </div>
                            

                            <!--<div v-for="o in 4" :key="o" class="text item">
                                {{'列表内容 ' + o }}
                            </div>-->
                        </el-card>
                    </div>
                    
                </el-tab-pane>
                <el-tab-pane label="已取消" name="third">
                    <div class="scrollLoad" v-infinite-scroll="loadList"
                        infinite-scroll-disabled="loading">
                        <el-card class="box-card" v-for="(item, idx) in result" :key="idx">
                            <div slot="header" class="clearfix">
                                <span style="color:gray">{{auditTypeEnum.canceled}}</span>
                                <el-button style="float: right; padding: 3px 0" type="text" @click="getInfo(item.formId,3)">查看详情</el-button>
                            </div>
                            <div class="text item">
                                {{'审批类型：'+item.flowNodeName}}
                            </div>
                            <div class="text item">
                                {{'访问人：'+item.visitorName}}
                            </div>
                            <div class="text item">
                                {{'被访人：'+item.intervieweeName}}
                            </div>
                            <div class="text item">
                                {{'被访人部门：'+item.intervieweeOrgName}}
                            </div>
                            <div class="text item">
                                {{'访问类型：'+item.visitTypeName}}
                            </div>
                            <div class="text item">
                                {{'访问开始时间：'+item.visitStartTime}}
                            </div>
                            <div class="text item">
                                {{'访问结束时间：'+item.visitEndTime}}
                            </div>
                            <!--<div v-for="o in 4" :key="o" class="text item">
                                {{'列表内容 ' + o }}
                            </div>-->
                        </el-card>
                    </div>
                    
                </el-tab-pane>
            </el-tabs> 
        </div>
    </div>
</template>

<script>
import auditTypeEnum from '@/commons/auditTypeEnum.js';
import auditTypeEnEnum from '@/commons/auditTypeEnEnum.js';

export default {
    name: 'approval',
    data(){
        return {
            auditTypeEnum:auditTypeEnum,
            auditTypeEnEnum:auditTypeEnEnum,
            loading: false,
            activeName: 'first',
            stateNo:1,//0草稿，1未审批，2已审批，3已取消
            openId:'',
            pageSize:3,
            infoId:-1,
            result:[
                {
                    id:1,
                    name:'',
                    age:'',
                    color:''
                }
            ]
        }
    },
    computed: {
        
    },
    created(){
        this.getOpenId();
        this.stateNo=1;
        this.loadCardList(this.stateNo,this.openId,this.pageSize);
    },
    methods: {

        //-------------------------------------------------------------------------
        //------------------------------初始化方法----------------------------------
        //-------------------------------------------------------------------------

        loadList(){
            this.pageSize+=3;
            this.loadCardList(this.stateNo,this.openId,this.pageSize);
        },

        loadCardList(stateNo,openId,pageSize){
            this.loading = true;
            this.$axios({
                url: '/wx/move/visitor/form',
                method: 'get',
                params:{openId:openId,stateNo:stateNo,pageSize:pageSize}
            })
            .then(res => {
                
                // console.log(res.data);
                if(res.status==200){
                    if(res.data.code==0){
                        this.result=res.data.result[0].list;
                        this.loading = false;
                    }
                    else{
                        this.loading = false;
                        this.$message({ type: 'error', message: '查询审批信息失败'});
                    } 
                }
                   
            })
            .catch(err => {
                this.loading = false;
                this.$message({ type: 'error', message: '查询审批信息失败'+err });
            })
            
        },

        getOpenId(){
            this.openId=localStorage.getItem("openid");
            if(!this.openId){
                const code = this.GetUrlParame('code') // 截取code  
                if (!code) {
                    var domine = window.location.href.split("#")[0]; // 微信会自动识别#    并且清除#后面的内容
                    //这里的axios是已封装过的
                    this.$axios({
                        url: '/wx/move/oauth',
                        method: 'get',
                        params:{callbackUrl:window.PRODUCTION_CONFIG.$globalUrl+'/approval'}
                    })
                    .then(res => {
                        let url=res.data.url
                        window.location.href = url;
                    })
                    .catch(err => {
                        this.$message({ type: 'error', message: '获取code失败'+err });
                        window.location.href = window.PRODUCTION_CONFIG.$globalUrl+'/error'
                    })
                } 
                else {
                    // console.log(code);
                    this.$axios({
                        url: '/wx/move/publicInfo',
                        method: 'get',
                        params:{code:code}
                    })
                    .then(res => {
                    //    console.log(res);
                        if (res) { 
                            localStorage.setItem("openid", res.data);
                            this.openId=localStorage.getItem("openid");
                            // this.$message({ type: 'info', message: res.data });
                            this.stateNo=1;
                            this.loadCardList(this.stateNo,this.openId,this.pageSize);
                            // return;
                        }
                        // window.location.replace('/#' + url);
                    })
                    .catch(err => {
                        this.$message({ type: 'error', message: '获取openid失败'+err });
                        window.location.href = window.PRODUCTION_CONFIG.$globalUrl+'/error'
                    })
                }
                // this.openId=localStorage.getItem("openid");
                // this.stateNo=1;
                // this.loadCardList(this.stateNo,this.openId,this.pageSize);
            }
            
        },
        GetUrlParame (parameName) {
            /// 获取地址栏指定参数的值
            /// <param name="parameName">参数名</param>
            // 获取url中跟在问号后面的部分
            var parames = window.location.search
            // 检测参数是否存在
            if (parames.indexOf(parameName) > -1) {
                var parameValue = ''
                parameValue = parames.substring(parames.indexOf(parameName), parames.length)
                // 检测后面是否还有参数
                    if (parameValue.indexOf('&') > -1) {
                        // 去除后面多余的参数, 得到最终 parameName=parameValue 形式的值
                        parameValue = parameValue.substring(0, parameValue.indexOf('&'))
                        // 去掉参数名, 得到最终纯值字符串
                        parameValue = parameValue.replace(parameName + '=', '')
                        return parameValue
                    }
                return ''
            }
        },

        //-------------------------------------------------------------------------
        //------------------------------增删改、跳转方法----------------------------------
        //-------------------------------------------------------------------------
        

        getInfo(id,state){
            this.$router.push({ name: 'approvalInfo',params:{id:id,type:'emp'} });
        },
        

        //-------------------------------------------------------------------------
        //------------------------------控件change、转换等方法----------------------
        //-------------------------------------------------------------------------

        handleClick(tab, event) {
            switch(tab.name){
                case "first":
                    this.stateNo=1;
                break;
                case "second":
                    this.stateNo=2;
                break;
                default:
                    this.stateNo=3;
            }
            this.pageSize=3;
            this.loadCardList(this.stateNo,this.openId,this.pageSize);
            // console.log(this.stateNo);
        },

        //-------------------------------------------------------------------------
        //------------------------------dialog相关方法----------------------
        //-------------------------------------------------------------------------

    }

}
</script>

<style scoped>
.box-container {
    max-width: 480px;
    width: 100%;
    
    overflow: auto;
  }
  #text{
      width:300px;
  }
.text {
    font-size: 14px;
    width:400px;
  }

  .item {
    margin-bottom: 10px;
    width:400px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 100%;
    margin-bottom:10px;
    box-shadow:none;
    webkit-box-shadow:none;
  }

  .scrollLoad{
      max-height: 800px;
        overflow-y: auto;
  }

  ::v-deep .el-tabs__nav-scroll{
  width: 80%!important;
  margin: 0 auto!important;
}
</style>